import { Center, Spinner } from '@omnipresentgroup/design-system';

//TODO: replication of Loading atom in omniplatform, consider other option when moving to Contractor App
export const Loading = () => (
  <Center.Absolute>
    <Spinner size="40" />
  </Center.Absolute>
);
